import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('base-modal-layout-content', {
  root: {
    states: ['hideTopDivider', 'hideBottomDivider'],
  },
  innerContent: {},
  topDivider: {},
  bottomDivider: {},
});
